// chat-web-app/src/components/chat/ChatPanel/ChatPanel.jsx
// CHANGES from original:
//   - getMessageByChannelId service call unchanged (already correct)
//   - Added grouping logic: hideAvatar + hideSenderName props to MessageBubble
//   - handleReaction pin guard added (blocks temp_ messages)
//   - Everything else (socket listeners, header, pinned bar, input) UNCHANGED

// import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
// import AppIcon from "../../../components/ui/AppIcon";
// import MessageBubble from "./MessageBubble";
// import DateSeparator from "./DateSeparator";
// import MessageInput from "./MessageInput";
// import PinnedMessageItem from "./PinnedMessageItem";
// import { useChat } from "../../../context/ChatContext";
// import { useAuth } from "../../../context/AuthContext";
// import { useSocket } from "../../../context/SocketContext";
// import { getChats, markAsRead, deleteChatMessage } from "../../../services/chatServices";
// import { getMessageByChannelId, deleteChannelMessage } from "../../../services/channelService";
// import { getFormattedDateLabel, isSameDay } from "../../../utils/dateUtils";

// export default function ChatPanel({ onRightPanelToggle, rightPanelOpen }) {
//     const { user } = useAuth();
//     const { activeChat, pinnedMessages, channelFiles, fetchPinnedMessages, fetchChannelFiles, handleUnpinMessage, handlePinMessage } = useChat();
//     const socket = useSocket();

//     // Compute conversation identifier: for channels use channel ID, for DMs use composite ID (sorted user IDs)
//     const conversationId = activeChat && user ? (
//         activeChat.type === "channel"
//             ? (activeChat.data._id || activeChat.data.id)
//             : [user._id || user.id, activeChat.data._id || activeChat.data.id].sort().join("_")
//     ) : null;

//     // For channel-specific operations (like fetching files), use actual channel ID (only valid for channels)
//     const actualChannelId = activeChat?.type === "channel" ? (activeChat.data._id || activeChat.data.id) : null;

//     const channelPinnedMessages = conversationId ? (pinnedMessages[conversationId] || []) : [];

//     const [messages, setMessages] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [typers, setTypers] = useState([]);
//     const messagesEndRef = useRef(null);

//     // ── Socket room management ───────────────────────────────────────────────
//     // Join channel or DM room when activeChat changes so we receive real-time messages
//     useEffect(() => {
//       if (!socket || !user) {
//         console.log("[ChatPanel] ⚠️ Socket room join skipped: no socket or user");
//         return;
//       }

//       let room = null;

//       if (activeChat) {
//         if (activeChat.type === 'channel') {
//           const channelId = activeChat.data._id || activeChat.data.id;
//           room = channelId;
//           console.log("[ChatPanel] 🔌 Joining channel room:", channelId);
//           socket.emit('joinChannel', channelId);
//         } else if (activeChat.type === 'dm') {
//           const userId = user._id || user.id;
//           const otherUserId = activeChat.data._id || activeChat.data.id;
//           const sortedIds = [userId, otherUserId].sort();
//           room = sortedIds.join('_');
//           console.log("[ChatPanel] 🔌 Joining DM room:", room, { userId, otherUserId });
//           socket.emit('joinRoom', { userId1: sortedIds[0], userId2: sortedIds[1] });
//         }
//       } else {
//         console.log("[ChatPanel] ⚠️ No activeChat, not joining any room");
//       }

//       return () => {
//         if (room && socket) {
//           console.log("[ChatPanel] 🔌 Leaving room:", room);
//           socket.emit('leaveChannel', room);
//         }
//       };
//     }, [socket, activeChat, user]);

//     // ── Fetch message history ─────────────────────────────────────────────────
//     const fetchHistory = useCallback(async () => {
//         console.log("[ChatPanel] 🔄 fetchHistory triggered:", {
//             activeChat: activeChat ? { type: activeChat.type, id: activeChat.data._id || activeChat.data.id } : null,
//             user: user?._id || user?.id,
//         });
//         if (!activeChat || !user) {
//             console.log("[ChatPanel] ⚠️ fetchHistory skipped: no activeChat or user");
//             return;
//         }
//         const userId = user._id || user.id;
//         setIsLoading(true);
//         try {
//             let res;
//             if (activeChat.type === "channel") {
//                 const channelId = activeChat.data._id || activeChat.data.id;
//                 console.log("[ChatPanel] 📥 Fetching channel messages for channelId:", channelId);
//                 res = await getMessageByChannelId(channelId);
//             } else {
//                 const otherUserId = activeChat.data._id || activeChat.data.id;
//                 console.log("[ChatPanel] 📥 Fetching DM messages for user:", { userId, otherUserId });
//                 res = await getChats(userId, otherUserId);
//             }
//             const messages = res?.data || [];
//             console.log("[ChatPanel] 📤 History fetch returned", messages.length, "messages");
//             if (messages.length > 0) {
//                 console.log("[ChatPanel] Sample history message:", {
//                     _id: messages[0]._id,
//                     text: messages[0].text?.substring(0, 30),
//                     sender: messages[0].sender,
//                     timestamp: messages[0].timestamp,
//                 });
//             }
//             setMessages(messages);
//         } catch (error) {
//             console.error("[ChatPanel] ❌ Error fetching history:", error.message);
//             setMessages([]);
//         } finally {
//             setIsLoading(false);
//         }
//     }, [activeChat, user]);

//     useEffect(() => {
//         fetchHistory();
//         if (activeChat && user) {
//             const userId = user._id || user.id;
//             const uniqueId = activeChat.type === "channel"
//                 ? activeChat.data._id || activeChat.data.id
//                 : [userId, activeChat.data._id || activeChat.data.id].sort().join("_");
//             markAsRead({ uniqueId, userId }).catch(console.error);
//         }
//     }, [activeChat, user, fetchHistory]);

//     useEffect(() => {
//         if (conversationId) fetchPinnedMessages(conversationId);
//     }, [conversationId, fetchPinnedMessages]);

//     useEffect(() => {
//         if (conversationId) {
//             fetchChannelFiles(
//                 conversationId,
//                 activeChat?.type || 'channel',
//                 activeChat?.type === 'dm' ? (activeChat?.data?._id || activeChat?.data?.id) : null
//             );
//         }
//     }, [conversationId, activeChat, fetchChannelFiles]);

//     // ── Socket listeners ──────────────────────────────────────────────────────
//     useEffect(() => {
//         if (!socket) return;
//         const myUserId = user?._id || user?.id;

//         const handleReceiveMessage = (data) => {
//             const isCurrentChat = activeChat?.type === "channel"
//                 ? data.channelId === (activeChat.data._id || activeChat.data.id) ||
//                 data.channel === (activeChat.data._id || activeChat.data.id)
//                 : (data.senderId === (activeChat?.data?._id || activeChat?.data?.id) ||
//                     data.receiverId === (activeChat?.data?._id || activeChat?.data?.id));

//             console.log("[ChatPanel] 📨 Socket message received:", {
//                 event: activeChat?.type === "channel" ? "receiveChannelMessage" : "receive-message",
//                 data: {
//                     _id: data._id,
//                     __tempId: data.__tempId,
//                     text: data.text?.substring(0, 30),
//                     sender: data.sender,
//                     channelId: data.channelId || data.channel,
//                     roomId: data.roomId,
//                 },
//                 isCurrentChat,
//             });

//             if (isCurrentChat) {
//                 setMessages(prev => {
//                     // Strong deduplication: check by _id (exclude temp IDs), OR by content+timestamp+sender
//                     const exists = prev.find(m => {
//                         // Exact match on real _id (non-temporary)
//                         if (m._id && data._id && m._id.toString() === data._id.toString() && !String(data._id).startsWith('temp_')) {
//                             console.log("[ChatPanel] 🔍 Duplicate: exact _id match", { m_id: m._id, data_id: data._id });
//                             return true;
//                         }
//                         // Temp ID match (optimistic UI messages)
//                         if (data.__tempId && m.__tempId && data.__tempId === m.__tempId) {
//                             console.log("[ChatPanel] 🔍 Duplicate: __tempId match", { m_tempId: m.__tempId, data_tempId: data.__tempId });
//                             return true;
//                         }
//                         // Fallback: same sender + text + timestamp (handles socket + history duplication)
//                         const mSenderId = m.sender?._id || m.senderId || m.sender;
//                         const dataSenderId = data.sender?._id || data.senderId || data.sender;
//                         if (mSenderId && dataSenderId && m.text === data.text && m.timestamp && data.timestamp) {
//                             const mTime = new Date(m.timestamp).getTime();
//                             const dataTime = new Date(data.timestamp).getTime();
//                             if (mSenderId.toString() === dataSenderId.toString() && mTime === dataTime) {
//                                 console.log("[ChatPanel] 🔍 Duplicate: sender+text+time match", { mTime, dataTime, sender: mSenderId });
//                                 return true;
//                             }
//                         }
//                         return false;
//                     });
//                     if (exists) {
//                         console.log("[ChatPanel] 🚫 Duplicate message suppressed, not adding to state");
//                         return prev;
//                     }
//                     console.log("[ChatPanel] ✅ New message added to state (total now:", prev.length + 1, ")");
//                     return [...prev, data];
//                 });
//             } else {
//                 console.log("[ChatPanel] 📭 Message not for current chat, ignoring");
//             }
//         };

//         const handleTyping = ({ userId, userName, typing }) => {
//             if (userId === myUserId) return;
//             setTypers(prev =>
//                 typing
//                     ? [...new Set([...prev, userName])]
//                     : prev.filter(t => t !== userName)
//             );
//         };

//         const handleMessageDeleted = (data) => {
//             const deletedId = data._id || data.id || data.chatId || data.messageId;
//             setMessages(prev => prev.filter(m => (m._id || m.id) !== deletedId));
//         };

//         const handleReactionAdded = (data) => {
//             setMessages(prev => prev.map(m =>
//                 (m._id || m.id) === data.messageId
//                     ? { ...m, reactions: data.reactions }
//                     : m
//             ));
//         };

//         // Pin events — refresh pinned messages bar
//         const handleMessagePinned = ({ channelId: cId }) => {
//             if (cId === conversationId) fetchPinnedMessages(conversationId);
//         };
//         const handleMessageUnpinned = ({ channelId: cId }) => {
//             if (cId === conversationId) fetchPinnedMessages(conversationId);
//         };

//         socket.on("receive-message", handleReceiveMessage);
//         socket.on("receiveChannelMessage", handleReceiveMessage);
//         socket.on("typing", handleTyping);
//         socket.on("messageDeleted", handleMessageDeleted);
//         socket.on("channelMessageDeleted", handleMessageDeleted);
//         socket.on("reaction-added", handleReactionAdded);
//         socket.on("messagePinned", handleMessagePinned);
//         socket.on("messageUnpinned", handleMessageUnpinned);

//         return () => {
//             socket.off("receive-message", handleReceiveMessage);
//             socket.off("receiveChannelMessage", handleReceiveMessage);
//             socket.off("typing", handleTyping);
//             socket.off("messageDeleted", handleMessageDeleted);
//             socket.off("channelMessageDeleted", handleMessageDeleted);
//             socket.off("reaction-added", handleReactionAdded);
//             socket.off("messagePinned", handleMessagePinned);
//             socket.off("messageUnpinned", handleMessageUnpinned);
//         };
//     }, [socket, activeChat, user, conversationId, fetchPinnedMessages]);

//     useEffect(() => {
//         messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//     }, [messages, typers]);

//     // ── Handle reactions / delete / pin ──────────────────────────────────────
//     const handleReaction = async (messageId, emoji) => {
//         if (!activeChat || !user) return;
//         const userId = user._id || user.id;

//         // ── Guard: never act on unsaved temp messages ─────────────────────────
//         if (!messageId || String(messageId).startsWith("temp_")) {
//             console.warn("[handleReaction] Blocked action on temp message:", messageId);
//             return;
//         }

//         if (emoji === "delete") {
//             try {
//                 if (activeChat.type === "channel") {
//                     await deleteChannelMessage(messageId);
//                 } else {
//                     await deleteChatMessage(userId, activeChat.data._id || activeChat.data.id, messageId);
//                 }
//             } catch (error) {
//                 console.error("Error deleting message:", error);
//             }
//             return;
//         }

//         if (emoji === "pin") {
//             if (conversationId) {
//                 await handlePinMessage(messageId, conversationId);
//             }
//             return;
//         }

//         socket?.emit("reaction-added", {
//             messageId,
//             emoji,
//             userId: userId,
//             userName: user.name,
//             targetId: activeChat.data._id || activeChat.data.id,
//             type: activeChat.type,
//         });
//     };

//     const scrollToMessage = (messageId) => {
//         const element = document.querySelector(`[data-message-id="${messageId}"]`);
//         if (element) element.scrollIntoView({ behavior: "smooth", block: "center" });
//     };

//     // ── Header info ───────────────────────────────────────────────────────────
//     const info = activeChat ? {
//         name: activeChat.data.name || activeChat.data.displayName || activeChat.data.username,
//         description: activeChat.type === "channel" ? activeChat.data.description : "Direct Message",
//         type: activeChat.type === "channel" ? (activeChat.data.isPrivate ? "private" : "public") : "dm",
//         memberCount: activeChat.data.members?.length || (activeChat.type === "dm" ? 2 : 0),
//     } : {
//         name: "Select a conversation",
//         description: "Choose a channel or teammate to start chatting",
//         type: "public",
//         memberCount: 0,
//     };

//     // ── Grouping logic ────────────────────────────────────────────────────────
//     // Two messages are "grouped" when they are from the same sender AND
//     // less than 5 minutes apart → hide avatar + sender name on follow-up messages
//     const isSameSender = (a, b) => {
//         if (!a || !b) return false;
//         const idA = (a.sender?._id || a.senderId)?.toString();
//         const idB = (b.sender?._id || b.senderId)?.toString();
//         if (idA && idB) return idA === idB;
//         // Fallback: compare by sender name (for DMs where sender is a string)
//         const nameA = a.sender?.name || a.senderName || a.sender || '';
//         const nameB = b.sender?.name || b.senderName || b.sender || '';
//         return nameA && nameB && nameA === nameB;
//     };

//     // ── Check if message is from current user ─────────────────────────────────
//     const isMessageFromCurrentUser = (msg) => {
//         // Channel messages: have sender._id or senderId
//         const msgSenderId = msg.senderId || (msg.sender && typeof msg.sender === 'object' && msg.sender._id);
//         if (msgSenderId) {
//             return msgSenderId.toString() === (user?._id || user?.id)?.toString();
//         }
//         // DM messages: sender is a string (name)
//         const msgSenderName = typeof msg.sender === 'string' ? msg.sender : (msg.sender && msg.sender.name);
//         return msgSenderName === user?.name;
//     };

//     const isWithin5Min = (a, b) => {
//         const tA = new Date(a.timestamp || a.createdAt).getTime();
//         const tB = new Date(b.timestamp || b.createdAt).getTime();
//         return Math.abs(tB - tA) < 5 * 60 * 1000;
//     };

//     if (!activeChat) {
//         return (
//             <div className="flex-1 flex flex-col items-center justify-center bg-[var(--bg-main)] text-[var(--text-muted)] space-y-4">
//                 <div className="w-20 h-20 rounded-full bg-white/5 flex items-center justify-center animate-pulse">
//                     <AppIcon name="ChatBubbleLeftRightIcon" size={40} className="opacity-20" />
//                 </div>
//                 <div className="text-center">
//                     <h3 className="text-white font-bold">Welcome to ChatFlow</h3>
//                     <p className="text-xs">Select a channel or DM to begin</p>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="flex flex-1 flex-col h-full bg-[var(--bg-main)] overflow-hidden relative">

//             {/* HEADER — unchanged from original */}
//             <header className="h-[64px] flex items-center justify-between px-6 glass border-b border-white/5 z-20">
//                 <div className="flex items-center gap-3 overflow-hidden">
//                     <div className="flex-shrink-0 text-xl font-bold opacity-30">
//                         {info.type === "private" ? "🔒" : info.type === "dm" ? "@" : "#"}
//                     </div>
//                     <div className="min-w-0">
//                         <div className="flex items-center gap-2">
//                             <h2 className="text-base font-bold text-white truncate">{info.name}</h2>
//                             <AppIcon name="ChevronDownIcon" size={14} className="opacity-40" />
//                         </div>
//                         <p className="text-[11px] text-[var(--text-muted)] truncate max-w-[400px]">
//                             {info.description}
//                         </p>
//                     </div>
//                 </div>
//                 <div className="flex items-center gap-1.5 ml-4">
//                     <div className="hidden sm:flex items-center gap-3 px-3 py-1.5 rounded-lg hover:bg-white/5 transition-colors cursor-pointer group border border-transparent hover:border-white/5">
//                         <div className="flex -space-x-2">
//                             {activeChat.data.members?.slice(0, 3).map((m, i) => (
//                                 <img key={i} src={m.profilePhoto || `https://i.pravatar.cc/100?u=${m.id}`} className="w-5 h-5 rounded-md border-2 border-[var(--bg-surface)] object-cover" alt={m.name || "Member"} />
//                             )) || <div className="w-5 h-5 rounded-md bg-white/10" />}
//                         </div>
//                         <span className="text-xs font-bold text-white/60 group-hover:text-white transition-colors">{info.memberCount}</span>
//                     </div>
//                     <div className="w-px h-5 bg-white/10 mx-1 hidden sm:block" />
//                     <ActionButton icon="MagnifyingGlassIcon" />
//                     <ActionButton icon="InformationCircleIcon" onClick={onRightPanelToggle} active={rightPanelOpen} />
//                     <ActionButton icon="EllipsisVerticalIcon" />
//                 </div>
//             </header>

//             {/* PINNED MESSAGES BAR — unchanged from original */}
//             {channelPinnedMessages.length > 0 && (
//                 <div className="px-6 py-3 bg-stone-500/5 border-b border-stone-500/10 overflow-hidden">
//                     <div className="flex items-center gap-2 mb-2">
//                         <AppIcon name="PinIcon" size={14} className="text-yellow-400" />
//                         <span className="text-xs font-bold text-yellow-400 uppercase tracking-wider">
//                             Pinned ({channelPinnedMessages.length})
//                         </span>
//                     </div>
//                     <div className="flex gap-3 overflow-x-auto pb-2 custom-scrollbar">
//                         {channelPinnedMessages.map(msg => (
//                             <PinnedMessageItem
//                                 key={msg._id || msg.id}
//                                 message={msg}
//                                 onUnpin={async () => {
//                                     await handleUnpinMessage(msg._id || msg.id, conversationId);
//                                 }}
//                                 onClick={(msg) => scrollToMessage(msg._id || msg.id)}
//                             />
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* MESSAGES AREA */}
//             <div className="flex-1 overflow-y-auto px-6 py-6 space-y-0.5 scroll-smooth custom-scrollbar">
//                 {isLoading ? (
//                     <div className="flex flex-col items-center justify-center h-20 opacity-40">
//                         <div className="w-6 h-6 border-2 border-stone-500 border-t-transparent rounded-full animate-spin mb-2" />
//                         <span className="text-[10px] font-bold uppercase tracking-widest">Loading...</span>
//                     </div>
//                 ) : messages.length === 0 ? (
//                     <div className="flex flex-col items-center justify-center h-full opacity-20">
//                         <AppIcon name="ChatBubbleOvalLeftIcon" size={48} className="mb-4" />
//                         <p className="text-sm font-medium">No messages yet. Start the conversation!</p>
//                     </div>
//                 ) : (
//                     messages.map((msg, idx) => {
//                         const prevMsg = idx > 0 ? messages[idx - 1] : null;
//                         const msgDate = new Date(msg.timestamp || msg.createdAt);
//                         const prevMsgDate = prevMsg ? new Date(prevMsg.timestamp || prevMsg.createdAt) : null;

//                         // Show date separator if it's first message or date changed
//                         const showDateSeparator = !prevMsg || !isSameDay(prevMsgDate, msgDate);

//                         const grouped = prevMsg && isSameSender(prevMsg, msg) && isWithin5Min(prevMsg, msg);

//                         return (
//                             <React.Fragment key={msg._id || msg.id || idx}>
//                                 {showDateSeparator && (
//                                     <DateSeparator
//                                         date={getFormattedDateLabel(msgDate)}
//                                     />
//                                 )}
//                                 <MessageBubble
//                                     message={msg}
//                                     isOwn={
//                                         (msg.sender?._id || msg.senderId || msg.sender)?.toString() ===
//                                         (user?._id || user?.id)?.toString()
//                                     }
//                                     onReaction={handleReaction}
//                                     hideAvatar={grouped}
//                                     hideSenderName={grouped}
//                                 />
//                             </React.Fragment>
//                         );
//                     })
//                 )}

//                 {/* Typing indicator — unchanged */}
//                 {typers.length > 0 && (
//                     <div className="flex items-center gap-3 animate-pulse opacity-60 mt-4">
//                         <div className="w-8 h-8 rounded-lg bg-white/5" />
//                         <div className="flex gap-1.5 px-3 py-2 rounded-2xl rounded-tl-none glass-strong">
//                             <span className="text-[11px] font-medium italic text-[var(--text-muted)]">
//                                 <span className="text-white/60 font-bold mr-1">{typers.join(", ")}</span>
//                                 {typers.length === 1 ? "is" : "are"} typing
//                                 <span className="inline-flex gap-0.5 ml-1.5">
//                                     <span className="w-1 h-1 rounded-full bg-stone-400 typing-dot" style={{ animationDelay: "0s" }} />
//                                     <span className="w-1 h-1 rounded-full bg-stone-400 typing-dot" style={{ animationDelay: "0.2s" }} />
//                                     <span className="w-1 h-1 rounded-full bg-stone-400 typing-dot" style={{ animationDelay: "0.4s" }} />
//                                 </span>
//                             </span>
//                         </div>
//                     </div>
//                 )}
//                 <div ref={messagesEndRef} className="h-4" />
//             </div>

//             {/* INPUT — unchanged */}
//             <MessageInput key={`${activeChat?.type}-${activeChat?.data?._id || activeChat?.data?.id}`} channelName={info.name} onMessagesUpdate={setMessages} />
//         </div>
//     );
// }

// function ActionButton({ icon, onClick, active }) {
//     return (
//         <button
//             onClick={onClick}
//             className={`p-2 rounded-lg transition-all duration-200 border border-transparent ${active
//                 ? "bg-stone-500/20 text-stone-400 border-stone-500/30"
//                 : "text-[var(--text-muted)] hover:text-white hover:bg-white/5"
//                 }`}
//         >
//             <AppIcon name={icon} size={20} />
//         </button>
//     );
// }

//======================================
//=======================================

import React, { useState, useRef, useEffect, useCallback } from "react";
import AppIcon from "../../../components/ui/AppIcon";
import MessageBubble from "./MessageBubble";
import DateSeparator from "./DateSeparator";
import MessageInput from "./MessageInput";
import PinnedMessageItem from "./PinnedMessageItem";
import CanvasView from "./CanvasView";
import { useChat } from "../../../context/ChatContext";
import { useAuth } from "../../../context/AuthContext";
import { useSocket } from "../../../context/SocketContext";
import { useThread } from "../../../context/ThreadContext";
import {
  getChats,
  markAsRead,
  deleteChatMessage,
} from "../../../services/chatServices";
import {
  getMessageByChannelId,
  deleteChannelMessage,
  markChannelAsRead,
} from "../../../services/channelService";
import { getFormattedDateLabel, isSameDay } from "../../../utils/dateUtils";
import toast from "react-hot-toast";

// ── Normalizer ────────────────────────────────────────────────────────────────
// Import the normalizer so every message — whether it comes from a REST
// re-fetch OR from a socket event — is converted into a consistent shape
// before it ever reaches MessageBubble.
//
// This is the single fix that prevents "Unknown" sender after page refresh:
//   • On re-fetch  → normalizeChannelMessages / normalizeDMMessages map the
//                    aggregation's senderInfo onto a guaranteed senderName field.
//   • On socket    → normalizeChannelMessage / normalizeDMMessage does the same
//                    for real-time payloads (including scheduled message emits).
import {
  normalizeChannelMessages,
  normalizeDMMessages,
  normalizeChannelMessage,
  normalizeDMMessage,
  normalizeReactions,
} from "../../../utils/messageNormalizer";
// ─────────────────────────────────────────────────────────────────────────────

export default function ChatPanel({
  onRightPanelToggle,
  rightPanelOpen,
  onSidebarToggle,
  desktopSidebarOpen,
}) {
  const { user } = useAuth();
  const {
    activeChat,
    pinnedMessages,
    fetchPinnedMessages,
    fetchChannelFiles,
    handleUnpinMessage,
    handlePinMessage,
    targetMessageId,
    setTargetMessageId,
    highlightQuery,
    onlineUsers,
    markChatAsRead,
    fetchCanvas,
    applyCanvasBlocks,
  } = useChat();
  const socket = useSocket();
  const { openThreadPanel } = useThread();

  const conversationId =
    activeChat && user
      ? activeChat.type === "channel"
        ? activeChat.data._id || activeChat.data.id
        : [user._id || user.id, activeChat.data._id || activeChat.data.id]
          .sort()
          .join("_")
      : null;

  // Stable string keys — used as useEffect deps instead of the full objects.
  // These only change when the user actually switches to a different chat.
  const activeChatType = activeChat?.type ?? null;
  const activeChatId = activeChat
    ? activeChat.data._id || activeChat.data.id
    : null;
  const myUserId = (user?._id || user?.id) ?? null;

  const channelPinnedMessages = conversationId
    ? pinnedMessages[conversationId] || []
    : [];

  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [typers, setTypers] = useState([]);
  const [mainView, setMainView] = useState("messages"); // "messages" | "canvas"
  const messagesEndRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const messageRefs = useRef({}); // { messageId -> DOM element }
  const prevMessagesLengthRef = useRef(0);
  const lastMessageRef = useRef(null);
  const [highlightMessageId, setHighlightMessageId] = useState(null); // Temporary highlight
  const scrollRetryRef = useRef(null); // Retry timer for scroll-to-message
  const unsentMessagesRef = useRef({});
  const [isNearBottom, setIsNearBottom] = useState(true);

  // ── Scroll Helpers ────────────────────────────────────────────────────────
  const scrollToBottom = useCallback((behavior = "auto") => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior });
    }
  }, []);

  const checkIsNearBottom = useCallback(() => {
    if (scrollContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        scrollContainerRef.current;
      // Threshold of 100px from the bottom
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;
      return distanceToBottom < 100;
    }
    return true;
  }, []);

  const handleScroll = useCallback(() => {
    setIsNearBottom(checkIsNearBottom());
  }, [checkIsNearBottom]);

  // ── Scroll Effects ────────────────────────────────────────────────────────

  // 1. Instant scroll to bottom on chat switch (Unconditional)
  useEffect(() => {
    if (conversationId && !isLoading) {
      scrollToBottom("auto");
      setIsNearBottom(true);
    }
  }, [conversationId, isLoading, scrollToBottom]);

  // 2. Unified Auto-Scroll for New Messages (Conditional)
  // Runs after DOM updates to ensure messages are rendered.
  // We use useLayoutEffect for precise timing during DOM mutations.
  // React.useLayoutEffect(() => {
  //   if (messages.length > prevMessagesLengthRef.current) {
  //     // If user is near bottom, scroll to the new message.
  //     // This handles both sender (outgoing) and receiver (incoming).
  //     if (isNearBottom) {
  //       scrollToBottom("smooth");
  //     }
  //   }
  //   prevMessagesLengthRef.current = messages.length;
  // }, [messages.length, isNearBottom, scrollToBottom]);

  //===========================================
  React.useLayoutEffect(() => {
    if (messages.length === 0) return;
    const lastMsg = messages[messages.length - 1];
    const lastMsgId = lastMsg?._id || lastMsg?.id || lastMsg?.__tempId;
    if (!lastMsgId || lastMsgId === lastMessageRef.current) return;
    lastMessageRef.current = lastMsgId;
    const isSender =
      (
        lastMsg?.sender?._id ||
        lastMsg?.senderId ||
        lastMsg?.sender
      )?.toString() === myUserId?.toString();
    if (isSender || isNearBottom) {
      scrollToBottom("smooth");
    }
    prevMessagesLengthRef.current = messages.length;
  }, [messages, isNearBottom, scrollToBottom, myUserId]);
  //===========================================

  // 3. Re-trigger scroll when async content (images/files) loads
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const observer = new ResizeObserver(() => {
      // If container grows (e.g. image loads) and we were at the bottom, stay at bottom
      if (isNearBottom) {
        scrollToBottom("smooth");
      }
    });

    observer.observe(container);
    return () => observer.disconnect();
  }, [isNearBottom, scrollToBottom]);
  // Deps: stable string IDs only — prevents room re-join on every refreshData.
  useEffect(() => {
    if (!socket || !myUserId || !activeChatId || !activeChatType) return;

    let room = null;
    if (activeChatType === "channel") {
      room = activeChatId;
      socket.emit("joinChannel", activeChatId);
      console.log("ChatPanel | joined channel room:", activeChatId);
    } else if (activeChatType === "dm") {
      const sortedIds = [myUserId, activeChatId].sort();
      room = sortedIds.join("_");
      socket.emit("joinRoom", { userId1: sortedIds[0], userId2: sortedIds[1] });
      console.log("ChatPanel | joined DM room:", room);
    }

    return () => {
      if (room) {
        socket.emit("leaveChannel", room);
        console.log("ChatPanel | left room:", room);
      }
    };
  }, [socket, activeChatId, activeChatType, myUserId]);

  // ── Fetch message history ─────────────────────────────────────────────────
  // Deps: only the stable string IDs — NOT the full activeChat/user objects.
  // This guarantees fetchHistory is recreated (and the fetch re-runs) ONLY
  // when the user actually switches to a different chat, not on every render
  // caused by refreshData updating activeChat's data fields.
  const fetchHistory = useCallback(async (opts = {}) => {
    // silent = refresh the current chat in place (no loading spinner, no clear).
    // Used when the app regains focus so messages missed while the tab was
    // backgrounded/suspended (e.g. an iOS PWA) appear without a flicker.
    const silent = opts.silent === true;
    if (!activeChatId || !myUserId || !activeChatType) return;
    if (!silent) {
      setIsLoading(true);
      // Clear previous chat's messages immediately so stale data never shows
      setMessages([]);
      // Clear stale message refs from previous chat
      messageRefs.current = {};
    }
    try {
      let raw = [];
      if (activeChatType === "channel") {
        console.log(
          "[ChatPanel] 📥 Fetching channel messages for:",
          activeChatId,
        );
        const res = await getMessageByChannelId(activeChatId);
        raw = res?.data || [];
        const normalized = normalizeChannelMessages(raw);
        console.log(
          "[ChatPanel] 📤 History:",
          normalized.length,
          "channel messages",
        );
        setMessages(normalized);
      } else {
        console.log("[ChatPanel] 📥 Fetching DM messages:", {
          myUserId,
          activeChatId,
        });
        const res = await getChats(myUserId, activeChatId);
        raw = res?.data || [];
        const normalized = normalizeDMMessages(raw, myUserId);
        console.log(
          "[ChatPanel] 📤 History:",
          normalized.length,
          "DM messages",
        );
        setMessages(normalized);
      }
    } catch (error) {
      console.error("[ChatPanel] ❌ Error fetching history:", error.message);
      // On a silent refresh, keep whatever is already on screen.
      if (!silent) setMessages([]);
    } finally {
      if (!silent) setIsLoading(false);
    }
  }, [activeChatId, activeChatType, myUserId]); // ← stable strings only

  // Trigger fetch + side-effects when the conversation changes.
  // conversationId is a derived string — stable across refreshData calls.
  useEffect(() => {
    if (!conversationId || !myUserId) return;
    fetchHistory();
    setTypers([]);
    // Cancel any pending scroll retry when switching chats
    if (scrollRetryRef.current) {
      clearTimeout(scrollRetryRef.current);
      scrollRetryRef.current = null;
    }
    const now = new Date().toISOString();

    // Mark as read on the server using the correct endpoint per chat type
    if (activeChatType === "channel") {
      markChannelAsRead(activeChatId, myUserId, now).catch(console.error);
    } else {
      markAsRead({
        uniqueId: conversationId,
        userId: myUserId,
        lastReadAt: now,
      }).catch(console.error);
    }
    // Reset unread badge immediately when user opens this chat (optimistic)
    markChatAsRead(activeChatId, activeChatType, now);

    // Emit socket event to sync other tabs instantly
    if (socket) {
      if (activeChatType === "channel") {
        socket.emit("channel:read", {
          channelId: activeChatId,
          userId: myUserId,
          lastReadAt: now,
        });
      } else if (activeChatType === "dm") {
        socket.emit("dm:read", {
          contactId: activeChatId,
          userId: myUserId,
          lastReadAt: now,
        });
      }
    }
  }, [
    conversationId,
    myUserId,
    fetchHistory,
    markChatAsRead,
    activeChatId,
    activeChatType,
    socket,
  ]);

  // ── Recover real-time state when the app returns to the foreground ─────────
  // iOS (and aggressive mobile browsers) suspend the PWA's JavaScript while
  // backgrounded, so the socket misses messages and may sit disconnected. On
  // resume we (1) force the socket to reconnect if it dropped and (2) silently
  // re-fetch the open conversation so any messages received while away appear
  // immediately — instead of only after switching chats.
  useEffect(() => {
    const handleResume = () => {
      if (document.visibilityState !== "visible") return;
      if (socket && socket.connected === false) {
        try {
          socket.connect();
        } catch (_) {}
      }
      // Re-join the room so new real-time messages keep flowing after a
      // reconnect (emits are queued by socket.io until the socket connects).
      if (socket && activeChatId && activeChatType) {
        if (activeChatType === "channel") {
          socket.emit("joinChannel", activeChatId);
        } else if (activeChatType === "dm") {
          const sortedIds = [myUserId, activeChatId].sort();
          socket.emit("joinRoom", {
            userId1: sortedIds[0],
            userId2: sortedIds[1],
          });
        }
      }
      if (conversationId) {
        fetchHistory({ silent: true });
      }
    };
    document.addEventListener("visibilitychange", handleResume);
    window.addEventListener("focus", handleResume);
    return () => {
      document.removeEventListener("visibilitychange", handleResume);
      window.removeEventListener("focus", handleResume);
    };
  }, [socket, conversationId, fetchHistory, activeChatId, activeChatType, myUserId]);

  // Opening a chat = reading it → dismiss any OS notifications for this chat so
  // the tray clears and the app-icon badge (derived from active notifications
  // while backgrounded) stays accurate. The unread count itself is cleared by
  // the read logic, which drops totalUnread → the badge clears via useAppBadge.
  useEffect(() => {
    if (!activeChatId || typeof navigator === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready
      .then((reg) => {
        if (!reg.getNotifications) return;
        return reg.getNotifications().then((notifs) => {
          notifs.forEach((n) => {
            const nid = (n.tag || n.data?.chatId)?.toString();
            if (nid && nid === activeChatId.toString()) n.close();
          });
        });
      })
      .catch(() => {});
  }, [activeChatId]);

  // Keep the OPEN conversation marked read while the user is actually looking
  // at it. Previously read-marking only ran on chat switch, so messages that
  // arrived in (or a reply sent to) the already-open chat left a stale unread
  // count on the sidebar AND the PWA badge — and, because only the REST
  // mark-as-read updates the server's readBy (the source of the count), the
  // count also stuck on the server and showed on the user's other devices
  // (e.g. phone). So here we: (1) clear locally right away, and (2) debounce an
  // authoritative server mark-as-read so it clears server-side and syncs across
  // devices.
  const readSyncTimerRef = useRef(null);
  useEffect(() => {
    if (!conversationId || !activeChatId || !activeChatType) return;
    if (
      typeof document !== "undefined" &&
      document.visibilityState !== "visible"
    )
      return;

    // Immediate local clear (idempotent — no-op when already 0).
    markChatAsRead(activeChatId, activeChatType, Date.now());

    // Debounced server read → updates readBy / channel lastReadAt so the count
    // clears server-side and the sender's other devices update too.
    if (readSyncTimerRef.current) clearTimeout(readSyncTimerRef.current);
    readSyncTimerRef.current = setTimeout(() => {
      const now = new Date().toISOString();
      if (activeChatType === "channel") {
        markChannelAsRead(activeChatId, myUserId, now).catch(() => {});
        socket?.emit("channel:read", {
          channelId: activeChatId,
          userId: myUserId,
          lastReadAt: now,
        });
      } else {
        markAsRead({
          uniqueId: conversationId,
          userId: myUserId,
          lastReadAt: now,
        }).catch(() => {});
        socket?.emit("dm:read", {
          contactId: activeChatId,
          userId: myUserId,
          lastReadAt: now,
        });
      }
    }, 700);

    return () => {
      if (readSyncTimerRef.current) clearTimeout(readSyncTimerRef.current);
    };
  }, [
    messages,
    conversationId,
    activeChatId,
    activeChatType,
    markChatAsRead,
    myUserId,
    socket,
  ]);

  // Switching conversations always lands on Messages (not a stale Canvas view).
  useEffect(() => {
    setMainView("messages");
  }, [conversationId]);

  useEffect(() => {
    if (conversationId) fetchPinnedMessages(conversationId);
  }, [conversationId, fetchPinnedMessages]);

  useEffect(() => {
    if (conversationId && fetchChannelFiles) {
      fetchChannelFiles(
        conversationId,
        activeChatType || "channel",
        activeChatType === "dm" ? activeChatId : null,
      );
    }
  }, [conversationId, activeChatType, activeChatId, fetchChannelFiles]);

  // ── Scroll to target message from search ───────────────────────────────────
  // When a message is clicked in search results, targetMessageId is set.
  // After messages load, scroll to that message and highlight it briefly.
  // Uses a retry loop because React renders asynchronously — the DOM element
  // may not exist yet when messages state first updates.
  useEffect(() => {
    if (!targetMessageId || isLoading) return;
    if (messages.length === 0) return;

    // Cancel any previous retry loop
    if (scrollRetryRef.current) {
      clearTimeout(scrollRetryRef.current);
      scrollRetryRef.current = null;
    }

    let attempts = 0;
    const MAX_ATTEMPTS = 15; // 15 × 100ms = 1.5s max wait
    const INTERVAL = 100;

    const tryScroll = () => {
      attempts++;
      const element = messageRefs.current[targetMessageId];

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        setHighlightMessageId(targetMessageId);
        setTimeout(() => setHighlightMessageId(null), 2500);
        setTargetMessageId(null);
        return;
      }

      if (attempts < MAX_ATTEMPTS) {
        scrollRetryRef.current = setTimeout(tryScroll, INTERVAL);
      } else {
        // Message not found in DOM after max retries — clear to avoid stale state
        console.warn(
          "[ChatPanel] scroll-to-message: element not found for id:",
          targetMessageId,
        );
        setTargetMessageId(null);
      }
    };

    // First attempt after a short delay to let React commit the render
    scrollRetryRef.current = setTimeout(tryScroll, 80);

    return () => {
      if (scrollRetryRef.current) {
        clearTimeout(scrollRetryRef.current);
        scrollRetryRef.current = null;
      }
    };
  }, [messages, targetMessageId, isLoading, setTargetMessageId]);

  // ── Refs for values needed inside socket handlers ─────────────────────────
  // Using refs means the handlers always read the latest value without
  // needing those values in the effect's dependency array.
  // This is the key pattern that prevents listener re-registration on every render.
  const activeChatRef = useRef(activeChat);
  const conversationIdRef = useRef(conversationId);
  const fetchPinnedRef = useRef(fetchPinnedMessages);
  const applyCanvasRef = useRef(applyCanvasBlocks);
  useEffect(() => {
    activeChatRef.current = activeChat;
  }, [activeChat]);
  useEffect(() => {
    conversationIdRef.current = conversationId;
  }, [conversationId]);
  useEffect(() => {
    fetchPinnedRef.current = fetchPinnedMessages;
  }, [fetchPinnedMessages]);
  useEffect(() => {
    applyCanvasRef.current = applyCanvasBlocks;
  }, [applyCanvasBlocks]);

  // ── Socket listeners ──────────────────────────────────────────────────────
  // Deps: [socket, conversationId] only.
  //   • socket   — must re-register if the socket instance changes
  //   • conversationId — must re-register when switching chats so
  //                      handleReceiveMessage filters for the right room
  // Everything else is read via refs so it never causes re-registration.
  useEffect(() => {
    if (!socket) return;

    const STATUS_RANK = { sending: 0, sent: 1, delivered: 2, seen: 3 };

    const handleReceiveMessage = (data) => {
      const chat = activeChatRef.current;
      const convId = conversationIdRef.current;
      const uid = myUserId;

      const currentConversationId = convId;

      const isCurrentChat =
        chat?.type === "channel"
          ? data.channelId?.toString() === currentConversationId?.toString() ||
          data.channel?.toString() === currentConversationId?.toString()
          : data.roomId?.toString() === currentConversationId?.toString() ||
          data.senderId?.toString() ===
          (chat?.data?._id || chat?.data?.id)?.toString() ||
          data.receiverId?.toString() ===
          (chat?.data?._id || chat?.data?.id)?.toString();

      console.log(
        "ChatPanel | receive-message fired | roomId:",
        data.roomId,
        "| senderId:",
        data.senderId,
        "| receiverId:",
        data.receiverId,
        "| currentConvId:",
        currentConversationId,
        "| isCurrentChat:",
        isCurrentChat,
      );

      if (!isCurrentChat) {
        console.log(
          "ChatPanel | receive-message ignored — not the active chat",
        );
        return;
      }

      const normalized =
        chat?.type === "channel"
          ? normalizeChannelMessage(data)
          : normalizeDMMessage(data, uid);

      setMessages((prev) => {
        // Replace optimistic message
        if (data.__tempId) {
          const idx = prev.findIndex(
            (m) => m.__tempId === data.__tempId || m._id === data.__tempId,
          );
          if (idx > -1) {
            const next = [...prev];
            next[idx] = { ...normalized, status: normalized.status || "sent" };
            return next;
          }
        }
        // Deduplicate by _id
        if (data._id && !String(data._id).startsWith("temp_")) {
          if (prev.some((m) => m._id?.toString() === data._id.toString()))
            return prev;
        }
        // Fallback: same sender + text within 2s
        const isDup = prev.some((m) => {
          const mSid = (m.sender?._id || m.senderId || m.sender)?.toString();
          const datSid = (
            data.sender?._id ||
            data.senderId ||
            data.sender
          )?.toString();
          if (!mSid || !datSid || mSid !== datSid || m.text !== data.text)
            return false;
          return (
            Math.abs(
              new Date(m.timestamp || m.createdAt).getTime() -
              new Date(data.timestamp || data.createdAt).getTime(),
            ) < 2000
          );
        });
        if (isDup) return prev;

        console.log(
          "ChatPanel | receive-message adding to state | _id:",
          data._id,
          "| tempId:",
          data.__tempId,
          "| total after:",
          prev.length + 1,
        );
        return [
          ...prev,
          { ...normalized, status: normalized.status || "sent" },
        ];
      });

      // Emit delivered for DMs or Channels
      if (
        data.senderId &&
        data._id &&
        (data.senderId || data.sender?._id)?.toString() !== uid?.toString()
      ) {
        if (chat?.type === "dm") {
          socket.emit("message_delivered", {
            messageId: data._id,
            senderId: data.senderId,
            roomId: currentConversationId,
          });
        } else if (chat?.type === "channel") {
          socket.emit("channel_message_delivered", {
            messageId: data._id,
            channelId: currentConversationId,
            userId: uid,
          });
        }
      }
    };

    const handleTyping = ({ userId, userName, typing }) => {
      if (userId === myUserId) return;
      setTypers((prev) =>
        typing
          ? [...new Set([...prev, userName])]
          : prev.filter((t) => t !== userName),
      );
    };

    const handleMessageUpdated = (data) => {
      const chat = activeChatRef.current;
      const uid = myUserId;
      const normalized =
        chat?.type === "channel"
          ? normalizeChannelMessage(data)
          : normalizeDMMessage(data, uid);

      setMessages((prev) =>
        prev.map((m) =>
          (m._id || m.id)?.toString() ===
            (normalized._id || normalized.id)?.toString()
            ? { ...m, ...normalized }
            : m,
        ),
      );
    };

    const handleMessageDeleted = (data) => {
      const id = data._id || data.id || data.chatId || data.messageId;
      setMessages((prev) => prev.filter((m) => (m._id || m.id) !== id));
    };

    const handleReactionAdded = (data) => {
      if (!data?.messageId || !Array.isArray(data.reactions)) return;
      setMessages((prev) =>
        prev.map((m) =>
          (m._id || m.id) === data.messageId
            ? { ...m, reactions: normalizeReactions(data.reactions) }
            : m,
        ),
      );
    };

    const handleMessagePinned = ({ channelId: cId }) => {
      const convId = conversationIdRef.current;
      if (cId === convId) fetchPinnedRef.current(convId);
    };
    const handleMessageUnpinned = ({ channelId: cId }) => {
      const convId = conversationIdRef.current;
      if (cId === convId) fetchPinnedRef.current(convId);
    };

    const handleCanvasUpdate = ({ conversationId: cId, blocks }) => {
      const convId = conversationIdRef.current;
      if (cId?.toString() === convId?.toString()) {
        applyCanvasRef.current?.(convId, blocks);
      }
    };

    // const handleMessageSent = ({ tempId, message }) => {
    //   setMessages((prev) =>
    //     prev.map((m) => {
    //       if (m.__tempId === tempId || m._id === tempId)
    //         return { ...m, status: "sent" };
    //       if (
    //         message?._id &&
    //         (m._id || m.id)?.toString() === message._id?.toString()
    //       )
    //         return { ...m, status: "sent" };
    //       return m;
    //     }),
    //   );
    // };

    //=======================================
    // REPLACE existing handleMessageSent inside the socket useEffect
    const handleMessageSent = ({ tempId, message }) => {
      setMessages((prev) =>
        prev.map((m) => {
          // Match by tempId OR by server _id (handles race where receiveChannelMessage arrived first)
          const matchByTemp = m.__tempId === tempId || m._id === tempId;
          const matchById =
            message?._id &&
            (m._id || m.id)?.toString() === message._id?.toString();
          if (matchByTemp || matchById) {
            // Remove from unsent tracking — confirmed by server
            if (tempId) delete unsentMessagesRef.current[tempId];
            return { ...m, _id: message?._id || m._id, status: "sent" };
          }
          return m;
        }),
      );
    };
    //=======================================

    //========================================
    const handleReconnect = () => {
      // Re-join room after reconnect (socket room membership is lost on disconnect)
      if (activeChatType === "channel") {
        socket.emit("joinChannel", activeChatId);
      } else if (activeChatType === "dm") {
        const sortedIds = [myUserId, activeChatId].sort();
        socket.emit("joinRoom", {
          userId1: sortedIds[0],
          userId2: sortedIds[1],
        });
      }

      // Retry any messages still in "sending" status
      setMessages((prev) => {
        prev.forEach((m) => {
          if (
            m.status === "sending" &&
            m.__tempId &&
            unsentMessagesRef.current[m.__tempId]
          ) {
            const { payload } = unsentMessagesRef.current[m.__tempId];
            socket.emit(payload.event, payload.data);
          }
        });
        return prev; // no state change, side-effect only
      });
    };
    //========================================

    const handleMessageDelivered = ({ messageId }) => {
      setMessages((prev) =>
        prev.map((m) => {
          if ((m._id || m.id)?.toString() !== messageId?.toString()) return m;
          if ((STATUS_RANK[m.status] ?? -1) >= STATUS_RANK.delivered) return m;
          return { ...m, status: "delivered" };
        }),
      );
    };

    const handleMessageSeen = ({ messageIds, messageId }) => {
      const ids = messageIds || (messageId ? [messageId] : []);
      if (!ids.length) return;
      const idSet = new Set(ids.map(String));
      setMessages((prev) =>
        prev.map((m) => {
          if (!idSet.has((m._id || m.id)?.toString())) return m;
          if ((STATUS_RANK[m.status] ?? -1) >= STATUS_RANK.seen) return m;
          return { ...m, status: "seen" };
        }),
      );
    };

    const handleChannelStatusUpdate = (update) => {
      // update: { messageId/messageIds, type: 'delivered'|'seen', userId }
      setMessages((prev) =>
        prev.map((m) => {
          const isTarget = update.messageIds
            ? update.messageIds.some(
              (id) => id.toString() === (m._id || m.id)?.toString(),
            )
            : (m._id || m.id)?.toString() === update.messageId?.toString();

          if (isTarget) {
            const field = update.type === "seen" ? "seenBy" : "deliveredTo";
            // const currentArr = m[field] || [];
            // if (!currentArr.includes(update.userId)) {
            //   return { ...m, [field]: [...currentArr, update.userId] };
            // }

            //=================================================
            const currentArr = (m[field] || []).map((id) => id?.toString());
            const normalizedUserId = update.userId?.toString();
            if (!currentArr.includes(normalizedUserId)) {
              return { ...m, [field]: [...currentArr, normalizedUserId] };
            }
            //=================================================
          }
          return m;
        }),
      );
    };

    socket.on("receive-message", handleReceiveMessage);
    socket.on("receiveChannelMessage", handleReceiveMessage);
    socket.on("typing", handleTyping);
    socket.on("messageDeleted", handleMessageDeleted);
    socket.on("channelMessageDeleted", handleMessageDeleted);
    socket.on("messageUpdated", handleMessageUpdated);
    socket.on("channelMessageUpdated", handleMessageUpdated);
    socket.on("reaction-added", handleReactionAdded);
    socket.on("messagePinned", handleMessagePinned);
    socket.on("messageUnpinned", handleMessageUnpinned);
    socket.on("canvas:update", handleCanvasUpdate);
    socket.on("message_sent", handleMessageSent);
    socket.on("message_delivered", handleMessageDelivered);
    socket.on("message_seen", handleMessageSeen);
    socket.on("messages_seen", handleMessageSeen);
    socket.on("channel_status_update", handleChannelStatusUpdate);

    // Update thread reply count on parent message when a thread reply is added/deleted
    const handleThreadCountUpdated = ({ parentMessageId, replyCount, lastReplyAt }) => {
      setMessages((prev) =>
        prev.map((m) => {
          const mId = (m._id || m.id)?.toString();
          if (mId !== parentMessageId?.toString()) return m;
          return { ...m, replyCount: replyCount ?? 0, lastReplyAt: lastReplyAt ?? m.lastReplyAt };
        }),
      );
    };
    socket.on("thread:count:updated", handleThreadCountUpdated);

    return () => {
      socket.off("receive-message", handleReceiveMessage);
      socket.off("receiveChannelMessage", handleReceiveMessage);
      socket.off("typing", handleTyping);
      socket.off("messageDeleted", handleMessageDeleted);
      socket.off("channelMessageDeleted", handleMessageDeleted);
      socket.off("messageUpdated", handleMessageUpdated);
      socket.off("channelMessageUpdated", handleMessageUpdated);
      socket.off("reaction-added", handleReactionAdded);
      socket.off("messagePinned", handleMessagePinned);
      socket.off("messageUnpinned", handleMessageUnpinned);
      socket.off("canvas:update", handleCanvasUpdate);
      socket.off("message_sent", handleMessageSent);
      socket.off("message_delivered", handleMessageDelivered);
      socket.off("message_seen", handleMessageSeen);
      socket.off("messages_seen", handleMessageSeen);
      socket.off("channel_status_update", handleChannelStatusUpdate);
      socket.off("thread:count:updated", handleThreadCountUpdated);
      socket.io?.off("reconnect", handleReconnect);
    };
  }, [socket, conversationId, myUserId]);

  useEffect(() => {
    if (messages.length > prevMessagesLengthRef.current) {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
    prevMessagesLengthRef.current = messages.length;
  }, [messages, typers]);

  useEffect(() => {
    if (!socket || messages.length === 0) return;

    const convId = conversationId;
    const chatType = activeChatType;
    let debounceTimer = null;
    const visibleUnseen = new Set();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting)
            visibleUnseen.add(entry.target.dataset.messageId);
        });
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          if (!visibleUnseen.size) return;
          const toMark = messages.filter((msg) => {
            const mId = (msg._id || msg.id)?.toString();
            if (!mId) return false;

            if (chatType === "dm") {
              if (msg.status === "seen") return false;
            } else {
              if (msg.seenBy?.includes(myUserId)) return false;
            }

            const msgSenderId = (
              msg.senderId ||
              msg.sender?._id ||
              msg.sender
            )?.toString();
            return (
              msgSenderId && msgSenderId !== myUserId && visibleUnseen.has(mId)
            );
          });

          if (!toMark.length) return;

          if (chatType === "dm") {
            socket.emit("mark_seen_batch", {
              messageIds: toMark.map((m) => m._id),
              senderId: (
                toMark[0].senderId ||
                toMark[0].sender?._id ||
                toMark[0].sender
              )?.toString(),
              roomId: convId,
            });
          } else if (chatType === "channel") {
            socket.emit("channel_message_seen", {
              messageIds: toMark.map((m) => m._id || m.id),
              channelId: convId,
              userId: myUserId,
            });
          }
          visibleUnseen.clear();
        }, 400);
      },
      { threshold: 0.5 },
    );

    messages.forEach((msg) => {
      const mId = (msg._id || msg.id)?.toString();
      if (!mId) return;

      let alreadySeen = false;
      if (chatType === "dm") {
        alreadySeen = msg.status === "seen";
      } else {
        alreadySeen = msg.seenBy?.includes(myUserId);
      }

      if (alreadySeen) return;

      const msgSenderId = (
        msg.senderId ||
        msg.sender?._id ||
        msg.sender
      )?.toString();
      if (!msgSenderId || msgSenderId === myUserId) return;

      const el = messageRefs.current[mId];
      if (el) observer.observe(el);
    });

    return () => {
      clearTimeout(debounceTimer);
      observer.disconnect();
    };
  }, [messages, socket, activeChatType, conversationId, myUserId]);

  // ── Reactions / delete / pin ──────────────────────────────────────────────
  // const handleReaction = async (messageId, emoji) => {
  //     if (!activeChat || !user) return;
  //     const userId = user._id || user.id;

  //     if (!messageId || String(messageId).startsWith("temp_")) {
  //         console.warn("[handleReaction] Blocked action on temp message:", messageId);
  //         return;
  //     }

  //     if (emoji === "delete") {
  //         // Optimistic delete handled by server socket event
  //         try {
  //             if (activeChat.type === "channel") {
  //                 await deleteChannelMessage(messageId);
  //             } else {
  //                 await deleteChatMessage(userId, activeChat.data._id || activeChat.data.id, messageId);
  //             }
  //         } catch (error) {
  //             console.error("Error deleting message:", error);
  //         }
  //         return;
  //     }

  //     if (emoji === "pin") {
  //         if (conversationId) await handlePinMessage(messageId, conversationId);
  //         return;
  //     }

  //     // ── OPTIMISTIC REACTION UPDATE ───────────────────────────────────────
  //     setMessages(prev => prev.map(m => {
  //         const msgId = m._id || m.id;
  //         if (msgId !== messageId) return m;

  //         const currentReactions = m.reactions || [];
  //         const existingReactionIndex = currentReactions.findIndex(r => r.emoji === emoji);

  //         let newReactions;
  //         if (existingReactionIndex > -1) {
  //             // Toggle off: remove this user's reaction
  //             const reaction = currentReactions[existingReactionIndex];
  //             const updatedUsers = reaction.users?.filter(u => u !== userId) || [];
  //             if (updatedUsers.length === 0) {
  //                 // Remove entire reaction entry if no users left
  //                 newReactions = currentReactions.filter((_, idx) => idx !== existingReactionIndex);
  //             } else {
  //                 // Update count and users
  //                 newReactions = [...currentReactions];
  //                 newReactions[existingReactionIndex] = {
  //                     ...reaction,
  //                     count: updatedUsers.length,
  //                     users: updatedUsers,
  //                 };
  //             }
  //         } else {
  //             // Add new reaction
  //             const newReaction = {
  //                 emoji,
  //                 count: 1,
  //                 users: [userId],
  //             };
  //             newReactions = [...currentReactions, newReaction];
  //         }

  //         return { ...m, reactions: newReactions };
  //     }));
  //     // ───────────────────────────────────────────────────────────────────────

  //     socket?.emit("reaction-added", {
  //         messageId,
  //         emoji,
  //         userId,
  //         userName: user.name,
  //         targetId: activeChat.data._id || activeChat.data.id,
  //         type: activeChat.type,
  //     });
  // };

  //================================
  // In ChatPanel.jsx, replace the handleReaction function (the optimistic reaction update section)
  // Only the optimistic reaction block changes — find this comment:
  // "── OPTIMISTIC REACTION UPDATE ───────────────────────────────────────"

  const handleReaction = async (messageId, emoji) => {
    if (!activeChat || !user) return;
    const userId = user._id || user.id;

    if (!messageId || String(messageId).startsWith("temp_")) {
      console.warn(
        "[handleReaction] Blocked action on temp message:",
        messageId,
      );
      return;
    }

    if (emoji === "delete") {
      if (activeChat.type === "channel") {
        // Optimistic removal for channel messages — instant UI update for sender
        setMessages((prev) =>
          prev.filter((m) => (m._id || m.id) !== messageId),
        );
      }
      try {
        if (activeChat.type === "channel") {
          await deleteChannelMessage(messageId);
        } else {
          await deleteChatMessage(
            userId,
            activeChat.data._id || activeChat.data.id,
            messageId,
          );
        }
        toast.success("Message deleted");
      } catch (error) {
        console.error("Error deleting message:", error);
        if (activeChat.type === "channel") {
          // Rollback optimistic removal on failure
          setMessages((prev) => [...prev]);
        }
        toast.error("Failed to delete message");
      }
      return;
    }

    if (emoji === "pin") {
      if (conversationId) await handlePinMessage(messageId, conversationId);
      return;
    }

    // ── OPTIMISTIC REACTION UPDATE ────────────────────────────────────────
    setMessages((prev) =>
      prev.map((m) => {
        const msgId = m._id || m.id;
        if (msgId !== messageId) return m;

        const currentReactions = m.reactions || [];
        const existingReactionIndex = currentReactions.findIndex(
          (r) => r.emoji === emoji,
        );

        let newReactions;
        if (existingReactionIndex > -1) {
          const reaction = currentReactions[existingReactionIndex];

          // Normalize users to strings for safe comparison regardless of
          // whether the server returned ObjectId objects or plain strings.
          const existingUsers = Array.isArray(reaction.users)
            ? reaction.users.map((u) =>
              u && typeof u.toString === "function" ? u.toString() : String(u),
            )
            : [];

          const userAlreadyReacted = existingUsers.includes(userId.toString());

          if (userAlreadyReacted) {
            // ── Toggle OFF: current user is removing their own reaction ──
            const updatedUsers = existingUsers.filter(
              (u) => u !== userId.toString(),
            );
            if (updatedUsers.length === 0) {
              // No users left — remove the entire reaction entry
              newReactions = currentReactions.filter(
                (_, idx) => idx !== existingReactionIndex,
              );
            } else {
              newReactions = [...currentReactions];
              newReactions[existingReactionIndex] = {
                ...reaction,
                count: updatedUsers.length,
                users: updatedUsers,
              };
            }
          } else {
            // ── Toggle ON: current user is adding to an existing reaction ──
            // Emoji already exists but this user hasn't reacted yet — add them.
            const updatedUsers = [...existingUsers, userId.toString()];
            newReactions = [...currentReactions];
            newReactions[existingReactionIndex] = {
              ...reaction,
              count: updatedUsers.length,
              users: updatedUsers,
            };
          }
        } else {
          // ── New reaction: emoji doesn't exist yet ──
          newReactions = [
            ...currentReactions,
            { emoji, count: 1, users: [userId.toString()] },
          ];
        }

        return { ...m, reactions: normalizeReactions(newReactions) };
      }),
    );
    // ─────────────────────────────────────────────────────────────────────

    socket?.emit("reaction-added", {
      messageId,
      emoji,
      userId,
      userName: user.name,
      targetId: activeChat.data._id || activeChat.data.id,
      type: activeChat.type,
    });
  };
  ///=================================

  // Open thread panel for a specific parent message
  const handleOpenThread = useCallback(
    (message) => {
      if (!message || !activeChat) return;
      const chatId = activeChat.data._id || activeChat.data.id;
      const chatType = activeChat.type; // "channel" | "dm"
      openThreadPanel(message, chatId, chatType);
    },
    [activeChat, openThreadPanel],
  );

  const scrollToMessage = (messageId) => {
    const element = document.querySelector(`[data-message-id="${messageId}"]`);
    if (element)
      element.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  // ── Header info ───────────────────────────────────────────────────────────
  const dmUserId =
    activeChat?.type === "dm"
      ? activeChat.data._id || activeChat.data.id
      : null;
  const isOnline = dmUserId ? onlineUsers.includes(dmUserId) : false;

  const info = activeChat
    ? {
      name:
        activeChat.data.name ||
        activeChat.data.displayName ||
        activeChat.data.username,
      description:
        activeChat.type === "channel" ? activeChat.data.description : null, // DM uses live indicator
      type:
        activeChat.type === "channel"
          ? activeChat.data.isPrivate
            ? "private"
            : "public"
          : "dm",
      memberCount:
        activeChat.data.members?.length || (activeChat.type === "dm" ? 2 : 0),
    }
    : {
      name: "Select a conversation",
      description: "Choose a channel or teammate to start chatting",
      type: "public",
      memberCount: 0,
    };

  // ── Grouping helpers ──────────────────────────────────────────────────────
  const isSameSender = (a, b) => {
    if (!a || !b) return false;
    const idA = (a.sender?._id || a.senderId)?.toString();
    const idB = (b.sender?._id || b.senderId)?.toString();
    if (idA && idB) return idA === idB;
    const nameA =
      a.senderName ||
      a.sender?.name ||
      (typeof a.sender === "string" ? a.sender : "");
    const nameB =
      b.senderName ||
      b.sender?.name ||
      (typeof b.sender === "string" ? b.sender : "");
    return nameA && nameB && nameA === nameB;
  };

  const isWithin5Min = (a, b) => {
    const tA = new Date(a.timestamp || a.createdAt).getTime();
    const tB = new Date(b.timestamp || b.createdAt).getTime();
    return Math.abs(tB - tA) < 5 * 60 * 1000;
  };

  if (!activeChat) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center bg-app-bg text-text-muted space-y-4">
        <div className="w-20 h-20 bg-app-surface flex items-center justify-center border border-border-subtle">
          <AppIcon
            name="ChatBubbleLeftRightIcon"
            size={40}
            className="text-ink/15"
          />
        </div>
        <div className="text-center">
          <h3 className="font-display text-text-primary font-semibold text-lg">
            Select a conversation
          </h3>
          <p className="text-sm text-text-muted">
            Choose a channel or DM to start chatting
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col h-full bg-app-bg overflow-hidden relative js-chat-main-container">
      {/* HEADER */}
      <header className="h-[56px] md:h-[64px] flex items-center justify-between px-3 md:px-6 bg-app-surface border-b border-border-subtle z-20">
        <div className="flex items-center gap-2 md:gap-3 overflow-hidden">
          {/* Desktop sidebar toggle — hidden on mobile (mobile uses hamburger in ChatInterface) */}
          <button
            onClick={onSidebarToggle}
            aria-label="Toggle sidebar"
            title="Toggle sidebar"
            className="hidden md:flex flex-shrink-0 w-8 h-8 items-center justify-center text-text-muted hover:text-text-primary hover:bg-black/5 transition-colors duration-200"
          >
            <AppIcon
              name={desktopSidebarOpen ? "ChevronLeftIcon" : "Bars3Icon"}
              size={18}
            />
          </button>
          <div className="flex-shrink-0 text-lg md:text-xl font-bold text-text-muted opacity-40">
            {info.type === "private" ? "🔒" : info.type === "dm" ? "@" : "#"}
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5 md:gap-2">
              <h2 className="font-display text-[14px] md:text-[15px] font-semibold text-text-primary truncate max-w-[140px] sm:max-w-[260px] md:max-w-none">
                {info.name}
              </h2>
              <AppIcon
                name="ChevronDownIcon"
                size={12}
                className="text-text-muted opacity-60 hidden sm:block"
              />
            </div>
            <p className="eyebrow eyebrow-10 truncate max-w-[140px] sm:max-w-[260px] md:max-w-[400px] hidden sm:block">
              {info.type === "dm" ? (
                <span className="flex items-center gap-1.5">
                  <span
                    className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${isOnline ? "bg-volt" : "bg-ink-meta"}`}
                  />
                  {isOnline ? "Online" : "Offline"}
                </span>
              ) : (
                info.description
              )}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-1.5 ml-3 md:ml-4">
          {/* Messages | Canvas view toggle */}
          <div className="flex items-center p-0.5 bg-black/[0.04] border border-border-subtle">
            <button
              onClick={() => setMainView("messages")}
              className={`px-2.5 md:px-3 py-1 text-[11px] md:text-[12px] font-semibold transition-colors ${
                mainView === "messages"
                  ? "bg-app-surface text-ink border border-border-subtle"
                  : "text-text-muted hover:text-text-primary"
              }`}
            >
              Messages
            </button>
            <button
              onClick={() => setMainView("canvas")}
              className={`px-2.5 md:px-3 py-1 text-[11px] md:text-[12px] font-semibold transition-colors flex items-center gap-1 ${
                mainView === "canvas"
                  ? "bg-app-surface text-ink border border-border-subtle"
                  : "text-text-muted hover:text-text-primary"
              }`}
            >
              <AppIcon name="DocumentTextIcon" size={13} />
              Canvas
            </button>
          </div>
          {/* <ActionButton icon="MagnifyingGlassIcon" /> */}
          <ActionButton
            icon="PanelRightOpenIcon"
            onClick={onRightPanelToggle}
            active={rightPanelOpen}
          />
          {/* <ActionButton icon="EllipsisVerticalIcon" /> */}
        </div>
      </header>
      {/* PINNED MESSAGES BAR */}
      {channelPinnedMessages.length > 0 && (
        <div className="px-6 py-2.5 bg-app-surface border-b border-border-subtle overflow-hidden flex items-center gap-4">
          <div className="flex items-center gap-2 flex-shrink-0">
            <AppIcon name="PinIcon" size={14} className="text-ink" />
            <span className="eyebrow eyebrow-10 !text-ink whitespace-nowrap">
              Pinned
            </span>
          </div>
          <div className="flex-1 flex gap-3 overflow-x-auto pb-1.5 custom-scrollbar">
            {channelPinnedMessages.map((msg) => (
              <PinnedMessageItem
                key={msg._id || msg.id}
                message={msg}
                onUnpin={async () => {
                  await handleUnpinMessage(msg._id || msg.id, conversationId);
                }}
                onClick={(msg) => scrollToMessage(msg._id || msg.id)}
              />
            ))}
          </div>
        </div>
      )}
      {mainView === "canvas" ? (
        <CanvasView conversationId={conversationId} chatType={activeChatType} />
      ) : (
        <>
      {/* MESSAGES AREA */}
      <div
        ref={scrollContainerRef}
        onScroll={handleScroll}
        className="flex-1 overflow-y-auto overflow-x-hidden px-3 md:px-6 py-4 md:py-6 space-y-1 scroll-smooth custom-scrollbar bg-app-bg"
      >
        {isLoading ? (
          <div className="flex flex-col items-center justify-center h-40">
            <div className="w-7 h-7 border-2 border-ink border-t-transparent rounded-full animate-spin mb-3" />
            <span className="eyebrow eyebrow-10">Loading history…</span>
          </div>
        ) : messages.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full text-text-muted opacity-50">
            <div className="w-20 h-20 bg-app-surface border border-border-subtle flex items-center justify-center mb-4">
              <AppIcon name="ChatBubbleOvalLeftIcon" size={36} />
            </div>
            <p className="text-sm font-semibold text-text-primary">No messages yet</p>
            <p className="text-xs">Start the conversation below</p>
          </div>
        ) : (
          messages.map((msg, idx) => {
            const prevMsg = idx > 0 ? messages[idx - 1] : null;
            const msgDate = new Date(msg.timestamp || msg.createdAt);
            const prevMsgDate = prevMsg
              ? new Date(prevMsg.timestamp || prevMsg.createdAt)
              : null;
            const showDateSeparator =
              !prevMsg || !isSameDay(prevMsgDate, msgDate);
            const grouped =
              prevMsg &&
              isSameSender(prevMsg, msg) &&
              isWithin5Min(prevMsg, msg);

            return (
              <React.Fragment key={msg._id || msg.id || idx}>
                {showDateSeparator && (
                  <DateSeparator date={getFormattedDateLabel(msgDate)} />
                )}
                <MessageBubble
                  ref={(el) => {
                    if (el) {
                      const msgId = msg._id || msg.id;
                      if (msgId) {
                        messageRefs.current[msgId] = el;
                      }
                    }
                  }}
                  key={msg._id || msg.id}
                  message={msg}
                  isOwn={
                    (
                      msg.sender?._id ||
                      msg.senderId ||
                      msg.sender
                    )?.toString() === myUserId?.toString()
                  }
                  onReaction={handleReaction}
                  onThread={handleOpenThread}
                  onUpdate={(updatedMsg) => {
                    const normalized =
                      activeChatType === "channel"
                        ? normalizeChannelMessage(updatedMsg)
                        : normalizeDMMessage(updatedMsg, myUserId);
                    setMessages((prev) =>
                      prev.map((m) =>
                        (m._id || m.id)?.toString() ===
                          (normalized._id || normalized.id)?.toString()
                          ? { ...m, ...normalized }
                          : m,
                      ),
                    );
                  }}
                  hideAvatar={grouped}
                  hideSenderName={grouped}
                  highlight={highlightMessageId === (msg._id || msg.id)}
                  highlightQuery={highlightQuery}
                  channelMemberCount={
                    (activeChat.data?.members?.length || 0) - 1
                  }
                />
              </React.Fragment>
            );
          })
        )}

        {typers.length > 0 &&
          (() => {
            // Resolve the first typer's avatar from channel members or the DM
            // partner; fall back to Ink initials so it's never a blank square.
            const first = typers[0];
            const members = activeChat?.data?.members || [];
            const match = members.find(
              (m) =>
                m?.name === first ||
                m?.displayName === first ||
                m?.userName === first,
            );
            const photo =
              match?.profilePhoto ||
              (activeChat?.type === "dm" && activeChat?.data?.name === first
                ? activeChat?.data?.profilePhoto
                : null);
            const initials = (first || "?")
              .trim()
              .split(/\s+/)
              .map((s) => s[0])
              .slice(0, 2)
              .join("")
              .toUpperCase();
            return (
              <div className="flex items-center gap-3 mt-4">
                {photo ? (
                  <img
                    src={photo}
                    alt={first}
                    className="w-9 h-9 rounded-full object-cover border border-border-subtle flex-shrink-0"
                  />
                ) : (
                  <span className="w-9 h-9 rounded-full bg-ink/[0.08] text-ink text-xs font-semibold flex items-center justify-center flex-shrink-0">
                    {initials}
                  </span>
                )}
                <div className="flex items-center gap-2 px-3 py-2 bg-app-surface border border-border-subtle">
                  <span className="text-[12px] text-text-secondary">
                    <span className="font-semibold text-ink">
                      {typers.join(", ")}
                    </span>{" "}
                    {typers.length === 1 ? "is" : "are"} typing
                  </span>
                  <span className="inline-flex gap-1">
                    <span
                      className="w-1.5 h-1.5 rounded-full bg-ink-faint typing-dot"
                      style={{ animationDelay: "0s" }}
                    />
                    <span
                      className="w-1.5 h-1.5 rounded-full bg-ink-faint typing-dot"
                      style={{ animationDelay: "0.2s" }}
                    />
                    <span
                      className="w-1.5 h-1.5 rounded-full bg-ink-faint typing-dot"
                      style={{ animationDelay: "0.4s" }}
                    />
                  </span>
                </div>
              </div>
            );
          })()}
        <div ref={messagesEndRef} className="h-4" />
      </div>
      {/* INPUT */}
      {/* <MessageInput
        key={`${activeChat?.type}-${activeChat?.data?._id || activeChat?.data?.id}`}
        channelName={info.name}
        onMessagesUpdate={setMessages}
        channelMembers={
          activeChat?.type === "channel"
            ? (activeChat.data?.members || []).filter(
                (m) => (m._id || m.id) !== (user?._id || user?.id),
              )
            : activeChat?.type === "dm" && activeChat?.data
              ? [activeChat.data]
              : []
        }
      /> */}
      {/*==================================*/}

      <MessageInput
        key={`${activeChat?.type}-${activeChat?.data?._id || activeChat?.data?.id}`}
        channelName={info.name}
        onMessagesUpdate={(updater) => {
          setMessages((prev) => {
            const next =
              typeof updater === "function" ? updater(prev) : updater;
            // Track newly added optimistic (sending) messages for reconnect retry
            next.forEach((m) => {
              if (
                m.status === "sending" &&
                m.__tempId &&
                !unsentMessagesRef.current[m.__tempId]
              ) {
                unsentMessagesRef.current[m.__tempId] = {
                  payload: {
                    event:
                      activeChatType === "channel"
                        ? "sendChannelMessage"
                        : "sendMessage",
                    data: { ...m, chatId: activeChatId },
                  },
                };
              }
              // Clean up confirmed messages
              if (m.status === "sent" && m.__tempId) {
                delete unsentMessagesRef.current[m.__tempId];
              }
            });
            return next;
          });
        }}
        channelMembers={
          activeChat?.type === "channel"
            ? (activeChat.data?.members || []).filter(
              (m) => (m._id || m.id) !== (user?._id || user?.id),
            )
            : activeChat?.type === "dm" && activeChat?.data
              ? [activeChat.data]
              : []
        }
        isNearBottom={isNearBottom}
        scrollToBottom={scrollToBottom}
      />
      {/* ================================== */}
        </>
      )}
    </div>
  );
}

function ActionButton({ icon, onClick, active }) {
  return (
    <button
      onClick={onClick}
      className={`p-2 rounded-lg transition-all duration-200 border border-transparent ${active
          ? "bg-primary/10 text-primary border-primary/20"
          : "text-text-muted hover:text-text-primary hover:bg-bg-muted"
        }`}
    >
      <AppIcon name={icon} size={18} />
    </button>
  );
}
